import $ from 'jquery';
import { persistRecommendations, restoreRecommendations } from '../../components/recommendations';

let INITIALIZED = false;

const CLASSES = {
  HIDDEN: 'd-none',
};

const SELECTORS = {
  CAROUSEL_TABS: '.product-detail__product-carousel-tabs',
  CAROUSELS: '.product-detail__product-carousel',
  PRODUCTS: '.product',
  TAB_LINK: '.nav-link',
  TAB: '.nav-item',
  get TAB_VISIBLE() { return `${this.TAB}:not(.${CLASSES.HIDDEN})`; },
  get TAB_ACTIVE_HIDDEN() { return `${this.TAB}.${CLASSES.HIDDEN} .active`; },
};

const handleCarouselVisibility = () => {
  const carousels = document.querySelectorAll(SELECTORS.CAROUSELS);
  const carouselTabContainers = document.querySelectorAll(SELECTORS.CAROUSEL_TABS);

  carousels.forEach((carousel) => {
    const hasProducts = !!carousel.querySelector(SELECTORS.PRODUCTS);
    const toggle = carousel.id && document.querySelector(`[href="#${carousel.id}"]`);

    carousel.classList.toggle(CLASSES.HIDDEN, !hasProducts);

    if (toggle) {
      const toggleTab = toggle.closest(SELECTORS.TAB);

      if (toggleTab) {
        toggleTab.classList.toggle(CLASSES.HIDDEN, !hasProducts);
      }
    }
  });

  const recommendationsHeading = document.querySelector('#recommendation-heading');

  if (recommendationsHeading) {
    const recommendationCallout = document.querySelector('#recommendations .product-recommendations__heading span');

    if (recommendationCallout !== null && recommendationsHeading !== null) {
      recommendationsHeading.innerHTML = recommendationCallout.innerHTML;
      recommendationsHeading.classList.remove('d-none');
      document.querySelector('#recommendations .product-recommendations__heading').classList.add('d-block');
      document.querySelector('#recommendations .product-recommendations__heading').classList.add('d-sm-none');
    }
  }
  const recentlyViewedCallout = document.querySelector('#pdp-dynamic-recently-viewed span');
  const recentlyViewedHeading = document.querySelector('.product-detail__recently-viewed .heading');

  if (recentlyViewedCallout !== null && recentlyViewedHeading !== null) {
    recentlyViewedHeading.innerHTML = recentlyViewedCallout.innerHTML;
    recentlyViewedHeading.classList.remove('d-none');
  }


  // Ensure that:
  //   - Tab containers that don't have any visible products in them remain hidden
  //   - Tab containers whose active tab got hidden get shown with the next available tab selected
  carouselTabContainers.forEach((carouselTabs) => {
    const activeTabHidden = !!carouselTabs.querySelector(SELECTORS.TAB_ACTIVE_HIDDEN);

    if (activeTabHidden) {
      const firstVisibleTab = carouselTabs.querySelector(SELECTORS.TAB_VISIBLE);

      if (firstVisibleTab) {
        $(`${SELECTORS.TAB_VISIBLE} ${SELECTORS.TAB_LINK}`).tab('show');

        carouselTabs.classList.remove(CLASSES.HIDDEN);
      }
    } else {
      carouselTabs.classList.remove(CLASSES.HIDDEN);
    }
  });
};

export default () => {
  handleCarouselVisibility();

  if (!INITIALIZED) {
    document.addEventListener('product:beforeAttributeSelect', persistRecommendations);
    document.addEventListener('product:afterAttributeSelect', restoreRecommendations.bind(handleCarouselVisibility));

    document.addEventListener('product:carousel-init', handleCarouselVisibility);

    INITIALIZED = true;
  }
};
